// extracted by mini-css-extract-plugin
export default {"searchModal":"SearchModal_searchModal__FZ5u-"};